import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Nav } from "@themesberg/react-bootstrap";

import { Routes } from "../../../routes";
import Account from "../../commons/account/Account";
import DepositWithdrawSettings from "../deposit-withdraw/DepositWithdrawSettings";
import PaymentMethod from "../../commons/payment-method/PaymentMethod";

const TABS = [
  { key: "account", label: "Tài khoản thanh toán" },
  { key: "deposit-withdraw", label: "Nạp/Rút tiền" },
  { key: "payment-method", label: "Hình thức thanh toán" },
];

export default () => {
  const location = useLocation();

  const initialTab = (() => {
    if (location.pathname === Routes.SettingDepositWithdraw.path)
      return "deposit-withdraw";
    if (location.pathname === Routes.SettingPaymentMethod.path)
      return "payment-method";
    return "account";
  })();

  const [tab, setTab] = useState(initialTab);

  return (
    <>
      <Nav
        variant="tabs"
        className="mb-3 mt-3"
        activeKey={tab}
        onSelect={(k) => setTab(k)}
      >
        {TABS.map((t) => (
          <Nav.Item key={t.key}>
            <Nav.Link eventKey={t.key}>{t.label}</Nav.Link>
          </Nav.Item>
        ))}
      </Nav>

      {tab === "account" && <Account />}
      {tab === "deposit-withdraw" && <DepositWithdrawSettings />}
      {tab === "payment-method" && <PaymentMethod />}
    </>
  );
};
